import { Button } from '@mui/material';
import React from 'react';

export function DonationTypeRadioButton(props) {
	const { inputId, isOptionSelected, donationTypeValue, donationTypeName, updateDonationType } = props;
	return (
		<Button
			id={inputId}
			variant={'outlined'}
			className="default-amount-card"
			fullWidth
			disableRipple 
			sx={{
				color: 'black',
				border: `1px solid ${isOptionSelected ? '#00884c' : '#d8d8d8'} !important`,
				fontWeight: isOptionSelected ? '600' : '400',
				transform: isOptionSelected ? 'scale(1.02)' : 'scale(1)',
				transition: 'transform 0.1s ease-in-out, font-weight 0.1s ease-in-out',
				boxShadow: isOptionSelected ? '0px 2px 6px rgba(0, 0, 0, 0.08)' : 'none',
			}}
			onClick={() =>
				updateDonationType({
					target: { name: 'donationType', value: donationTypeValue },
				})
			}
		>
			{donationTypeName}
		</Button>
	);
}
